
define('text!modules/reporting/campaigns/contextual/templates/contextual.html',[],function () { return '<div class="w-panel-body w-contextual-panel"></div>\n';});

